import { TabStyles } from '@tableau/widgets';
import { CommonStyles } from '../../common/react/CommonStyles';
import { cssClass } from '../../style';

const cssPrefix = 'DataRoleDefinitionSubspaceShared';

export const sectionTitleClass = cssClass(cssPrefix, 'sectionTitle', {
  fontSize: '15px',
  paddingBottom: TabStyles.Spacing.DefaultSpace,
  display: 'flex',
  justifyContent: 'space-between',
  fontFamily: CommonStyles.Fonts.HeaderFont,
  marginTop: TabStyles.Spacing.MediumSpace,
});

export const boldClass = cssClass(cssPrefix, 'bold', {fontFamily: CommonStyles.Fonts.HeavyFont});
